import React, { ChangeEvent } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { ReactComponent as Loader } from "../../../../../resources/images/Rolling.svg";
import UseEditProfilCtr from "../../../../../controller/profil-ctr/use-edit-profil-ctr";

export type IpropsModal = {
  showEditModal: boolean;
  cancelChange: () => void;
  isLoaderShow: boolean;
  submitCompanyGuest: any;
};

export default function ModalEditGuestCompany(props: IpropsModal) {
  const { registerGuest, handleGuest, errorGuest, dataCompleted, userState } =
    UseEditProfilCtr();

  return (
    <Modal
      show={props?.showEditModal}
      onHide={() => props?.cancelChange()}
      className="modalDevinsider medium"
    >
      <form onSubmit={handleGuest(props?.submitCompanyGuest)}>
        <Modal.Header closeButton>
          <Modal.Title>Company details</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="contentBorder row m-0 p-0">
            <div className="col-12 p-0 form-group required">
              <label htmlFor="company">Company name</label>
              {errorGuest.companyName?.type === "required" && (
                <div className={`container-error pl-2 "d-inline`}>
                  <span className="error-red"> error </span>
                  <span className="txt-error">This field is required</span>
                </div>
              )}
              <input
                type="text"
                className="input-text form-control"
                {...registerGuest("companyName", {
                  required: true,
                })}
              />
            </div>

            <div className="col-12 p-0 form-group required">
              <label htmlFor="company">Website</label>
              {errorGuest.website?.type === "required" && (
                <div className={`container-error pl-2 "d-inline`}>
                  <span className="error-red"> error </span>
                  <span className="txt-error">This field is required</span>
                </div>
              )}
              <input
                type="text"
                className="input-text form-control"
                {...registerGuest("website", {
                  required: true,
                })}
              />
            </div>

            <div className="col-6 form-group required p-0 pr-1">
              <label htmlFor="location">Location</label>
              {errorGuest.location?.type === "required" && (
                <div className={`container-error pl-2 "d-inline`}>
                  <span className="error-red"> error </span>
                  <span className="txt-error">This field is required</span>
                </div>
              )}
              <select
                className="custom-select"
                {...registerGuest("location", {
                  required: true,
                })}
              >
                {dataCompleted?.country?.map((element: any, index: number) => (
                  <option
                    key={index}
                    value={element.country_name}
                    selected={
                      element.country_name == userState?.country?.country_name
                    }
                  >
                    {`${element?.country_name}`}
                  </option>
                ))}
              </select>
            </div>
            <div className="col-6 form-group p-0 pl-1">
              <label htmlFor="first-name">&nbsp;</label>
              <input
                type="text"
                className="input-text form-control"
                {...registerGuest("city")}
                placeholder="City"
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button className="cancelbtn" onClick={() => props?.cancelChange()}>
            Cancel
          </Button>
          <Button
            className="validate"
            type="submit"
            // disabled={isLoaderShow}
          >
            {props?.isLoaderShow ? <Loader /> : "Save"}
          </Button>
        </Modal.Footer>
      </form>
    </Modal>
  );
}
